import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import "./common/common.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import VForm from "vform-builds";

import "vform-builds/dist/VFormDesigner.css"; //引入VForm样式
Vue.use(VideoPlayer);
Vue.use(VForm);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require("./assets/img/error.png"),
  //加载时显示的GIF图
  loading: require("./assets/img/loading.gif"),
  //尝试加载几次
  attempt: 1,
});

Vue.config.productionTip = false;

//设置超时时间
axios.defaults.timeout = 5000;
//设置api地址
//全局定义axios
axios.defaults.baseURL = "http://127.0.0.1:80/prod-api/";
Vue.prototype.$http = axios;
import { getFunctionListApi, getVirtualImageApi } from "./api/homeApi";
getVirtualImageApi().then((res) => {
  Vue.prototype.VirtualImage = res.data[0].url;
});
getFunctionListApi("").then((res) => {
  Vue.prototype.MainMenuList = res.data;
});
// 图片服务器地址
let protocol =window.location.protocol;//协议
let host = window.location.host;//主机
Vue.prototype.imgserver = protocol +"//" + host+"/prod-api";
// Vue.prototype.imgserver = "http://api-1.zr-net.com/prod-api";

import Router from "vue-router";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
